import { Box, Typography } from "@mui/material";
import FormInput from "./FormInput";
import { object, string, TypeOf } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useLoginUserMutation } from "../../redux/api/authApi";
import { LoadingButton as _LoadingButton } from '@mui/lab';
import styled from "@emotion/styled";
import { useEffect } from "react";
import MyToastShow from "../Layout/MyToast";
import { useAppDispatch } from "../../redux/store";
import { LocalStoreKey, LocalStoreManager } from "../../utils/LocalStoreManager";
import jwtDecode from "jwt-decode";


const LoadingButton = styled(_LoadingButton)`
  padding: 0.6rem 0;
  font-weight: 500;
  &:hover {
    transform: translateY(-2px);
  }
`;

const loginSchema = object({
    email: string()
        .min(1, 'Necesitas ingresar un email')
        .email('El email no es valido'),
    password: string()
        .min(1, 'Necesitas ingresar una contraseña')
        .min(5, 'Debe ser más larga que 5 caracteres')
        .max(32, 'Elegí una menor a 32 caracteres'),
});

export type LoginInput = TypeOf<typeof loginSchema>;


const LoginForm = () => {

    const [loginUser, { isLoading, isError, error, isSuccess, data: response }] =
        useLoginUserMutation();

    const navigate = useNavigate();
    const location = useLocation();
    const from = ((location.state as any)?.from.pathname as string) || '/';
    const dispatch = useAppDispatch();


    const methods = useForm<LoginInput>({
        resolver: zodResolver(loginSchema),
    });
    const {
        handleSubmit
    } = methods;

    const onSubmitHandler: SubmitHandler<LoginInput> = (values) => {
        loginUser(values);

    };

    useEffect(() => {
        if (isSuccess && response) {
            MyToastShow({ type: 'success', message: 'Logueado correctamente' });
            
            LocalStoreManager.set(LocalStoreKey.LOCALSTORE_TOKEN, response.data.token);
            const decoded = jwtDecode(response.data.token);
            dispatch({ type: 'userSlice/setUser', payload: decoded });


            if (location.pathname !== '/carrito') {
                navigate(from);
            }
        }
        else if (isError) {

            // eslint-disable-next-line react-hooks/exhaustive-deps
            //@ts-ignore
            if (error.status === 'FETCH_ERROR') {
                MyToastShow({ type: 'error', message: "Error de conexión con el servidor" });
                navigate("/login")
                return
            } else {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                //@ts-ignore
                MyToastShow({ type: 'error', message: error.data.message });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);


    return (
        <FormProvider {...methods}>
            <Box
                component='form'
                onSubmit={handleSubmit(onSubmitHandler)}
                noValidate
                autoComplete='off'
                maxWidth='27rem'
                width='100%'
                sx={{
                    p: { xs: '1rem', sm: '2rem' },
                    borderRadius: 2,

                }}
            >
                <FormInput name='email' label='Email' type='email' />
                <FormInput name='password' label='Contraseña' type='password' />


                <Link to={'/recuperarcuenta'}>

                    <Typography
                        sx={{ fontSize: '0.9rem', mb: '1rem', textAlign: 'right' }}
                    >
                        Olvidaste la contraseña?

                    </Typography>
                </Link>


                <LoadingButton
                    variant='contained'
                    sx={{ mt: 1 }}
                    fullWidth
                    disableElevation
                    type='submit'
                    loading={isLoading}
                >
                    Ingresar
                </LoadingButton>

                <Typography sx={{ fontSize: '0.9rem', mt: '1rem' }}>
                    No tenés cuenta? <Link to={'/register'}>Registrate</Link>
                </Typography>
            </Box>
        </FormProvider>
    );
}

export default LoginForm;

